<template>
    <div class="bg-gray2">
        <div v-if="mobiles.length > 0" class="container-fluid">
            <!--desktop-->
            <div class="d-none d-xxl-block py-2 mb-3 mt-2 grid-4col">
                <h2 class="no-signature">
                    {{ title }}
                </h2>
                <div class="row">
                    <div v-for="(device, index) in mobiles" :key="device.name" class="col-3">
                        <device-history
                            :track-zone="trackZone"
                            :device="device"
                            :intention="intention"
                            :index="index + 1"
                            :is-from-mobile-detail="isFromMobileDetail"
                        />
                    </div>
                </div>
            </div>

            <!--mobile-->
            <div class="d-xxl-none swiper-1row py-2 mb-3 mt-2">
                <h2 class="no-signature mb-1">
                    {{ title }}
                </h2>
                <div class="ob1-carrousel swiper-container history-swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(device, index) in mobiles"
                            :key="device.name"
                            class="swiper-slide"
                        >
                            <device-history
                                :track-zone="trackZone"
                                :device="device"
                                :intention="intention"
                                :index="index + 1"
                                :is-from-mobile-detail="isFromMobileDetail"
                            />
                        </div>
                    </div>
                    <button class="swiper-button-prev" title="Slide précédente" tabindex="-1">
                        <span class="visually-hidden">Slide précédente</span>
                    </button>
                    <button class="swiper-button-next" title="Slide suivante" tabindex="-1">
                        <span class="visually-hidden">Slide suivante</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DeviceHistory from "./DeviceHistory.vue";

export default {
    name: "MobilesViewsHistory",
    components: {DeviceHistory},
    props: {
        mobiles: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        trackZone: {
            type: String,
            required: true
        },
        intention: {
            type: String,
            required: true
        },
        isFromMobileDetail: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: true,
        }
    },
    mounted() {
        const swiper = new Swiper(".history-swiper-container", {
            slidesPerView: "auto",
            spaceBetween: 30,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initialSlide: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        window.addEventListener("resize", () => {
            this.updateLayout();
        });
        this.updateLayout();
    },
    methods: {
        updateLayout() {
            this.alignItemsVertically(".swiper-1row .device-name-wrapper");
            this.alignItemsVertically(".grid-4col .device-name-wrapper");
        },
        alignItemsVertically(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            elts.forEach(elt => elt.style.removeProperty("height"));
            const maxHeight = this.getMaximumHeight(selector);
            if (maxHeight === 0) {
                return;
            }
            elts.forEach(elt => $(elt).height(maxHeight));
        },
        getMaximumHeight(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            const heights = elts.map((elt, index) => {
                const h = $(elt).height();
                return h;
            });
            return Math.max(...heights);
        },
    },
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.ob1-carrousel .ob1-carrousel-controls, .ob1-carrousel .swiper-button-next, .ob1-carrousel .swiper-button-prev {
    top: 42%;
    background: black;
}

.swiper-1row > div {
    overflow: hidden;
}

.swiper-slide {
    width: px-to-rem(238);
    @media(min-width: #{map-get($grid-breakpoints, sm)}) {
        width: px-to-rem(280);
    }
}
</style>
